<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiAlertCircleOutline, mdiCheckCircleOutline } from "@mdi/js"
  import type { PrintSelectionPreviewRow } from "../../../../../../../../_shared/_logic/print-selection-preview"

  let { row }: { row: PrintSelectionPreviewRow } = $props()

  const status = $derived({
    value: row.recommendation_reason_code || "print_recommendation",
    label: row.recommendation_tag_label,
    color:
      !row.recommended_print &&
      row.printable &&
      !["Erledigt", "Zugestellt"].includes(row.recommendation_tag_label)
        ? "neutral"
        : row.recommendation_tag_color,
    icon:
      row.recommendation_tag_label === "Nicht nötig"
        ? mdiCheckCircleOutline
        : mdiAlertCircleOutline,
    description: row.recommendation_text,
  })
  const tooltip = $derived(row.disabled_reason || row.recommendation_text)
</script>

<StatusTag
  size="sm"
  {status}
  subLabel={row.recommendation_short_reason}
  disableTitle={true}
  tooltipContent={tooltip}
/>
